
import * as React from 'react'
import * as styles from './CloseButton.module.scss'

interface CloseButtonProps {
  onClick: Function
}

// TODO(AVWebStorefront-814): Move close button to DVUI
const CloseButton = ({ onClick }: CloseButtonProps) => (
  <svg className={styles.CloseButton} onClick={() => onClick()}>
    <defs></defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path d="M26.5359445,24.3809524 L31.9234247,18.9934721 L29.7684326,16.83848 L24.3809524,22.2259603 L18.9934721,16.83848 L16.83848,18.9934721 L22.2259603,24.3809524 L16.83848,29.7684326 L18.9934721,31.9234247 L24.3809524,26.5359445 L29.7684326,31.9234247 L31.9234247,29.7684326 L26.5359445,24.3809524 Z M24,0 C37.2552,0 48,10.7448 48,24 C48,37.2552 37.2552,48 24,48 C10.7448,48 0,37.2552 0,24 C0,10.7448 10.7448,0 24,0 Z" id="Combined-Shape" fill="#FFFFFF"></path>
    </g>
  </svg>
)

export default CloseButton
